export default "__VITE_ASSET__BmhVBmAp__"